/**
 * VoxPop Review app created by karora on 11/03/17.
 */
import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {ProfileService} from "./services/profile.service";
import {UserProfile} from "./types/user-profile";
import {trigger, state, style, transition, animate} from '@angular/animations';

@Component({
  moduleId: module.id,
  selector: 'voxpop-review',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translateX(0%)'
      })),
      state('out', style({
        transform: 'translateX(-100%)'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
  ],
})

export class AppComponent implements OnInit {
  private static title = 'VoxPop Review';
  public menuState: string = 'out';

  constructor(
    private router: Router,
    private profileService: ProfileService,
  ) {}

  ngOnInit(): void {
    try {
      this.profileService.GetProfile().subscribe(
        profile => {
          AppComponent.SetUser(profile);
        },
      );
    } catch (e) {
      console.log(e);
    }
    if (!ProfileService.IsLoggedIn()) {
      let c = document.getElementById("content");
      if (c) {
        c.innerHTML = `<h2 style='background-color:#eee;text-align:center'><a href='/auth/login'>Click here to log in</a></h2>`;
      }
    } else {
      this.router.events.subscribe(() => {
        this.hideMenu();
      });
    }
  }

  public static SetTitle(newTitle: string):void  {
    AppComponent.title = newTitle;
    document.getElementById("title").innerText = newTitle;
  }

  public static SetUser(profile: UserProfile): void {
    let userShite = document.getElementById("username");
    if (userShite && profile && profile.social.name) {
      try {
        // userShite.getElementsByTagName("a")[0].innerText = profile.social.name;
      } catch(e) {
        userShite.innerText = profile.social.name;
      }
    }
  }

  public static zpad(v:any, n: number):string {
    let s: string = '000000000000' + v;
    return s.substring(s.length - n);
  }

  toggleMenu(): void {
    this.menuState = this.menuState === 'out' ? 'in' : 'out';
  }

  hideMenu(): void {
    this.menuState = 'out';
  }
}
